import React, { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react';
import { Config, QuizContainer, QuizData } from '../App';
import i18n from '../i18n';
import XAPIService from '../integrations/Xapi';
import useCustomEvents from './useCustomEvents';
import { InteractiveLink } from '../components/InteractiveLinks';




const configJSON = {
  player_type: 'general', //hardcoded for now the player type
  video_version_id: 'bf812766-56db-4565-92bc-3f7fa27f4767',
  passing_percentage: 70,
  display_result: 'true',
  language: 'de_De',
  quizzes: [
    {
      type: 'fill_in_blanks',
      text: 'Der Prozess kann auf zwei verschiedene #0 gestaltet werden.',
      times_in_video: [13.8125],
      maxTries: 3,
      wordsToFill: [{ id: '0', correct: 'Arten', text: ['Arten', 'Weisen', 'Methoden'] }],
    },
    {
      type: 'match_pairs',
      questions: [
        {
          id: '0',
          text: 'Was wurde zur Beschleunigung der Prozesse unternommen?',
        },
        { id: '1', text: 'Wann trat das novellierte Regelwerk in Kraft?' },
        {
          id: '2',
          text: 'Wie wird die finanzielle Stabilit\u00e4t des Systems erh\u00f6ht?',
        },
        {
          id: '3',
          text: 'Was symbolisiert die Einf\u00fchrung einer Audit Unit?',
        },
      ],
      answers: [
        { id: '2', text: '8. Januar 2024' },
        { id: '1', text: 'Aufbau eines Zusatzfonds' },
        { id: '0', text: 'Beschleunigung der Entscheidungsprozesse this is i si si sidj' },
        { id: '3', text: 'St\u00e4rkung der internen \u00dcberpr\u00fcfung' },
      ],
      answerMapping: { '1': '2', '0': '0', '3': '3', '2': '1' },
      times_in_video: [145.0],
      maxTries: 2,
    },
    {
      type: 'match_pairs',
      questions: [
        {
          id: '0',
          text: 'Abschlusszeitpunkt der Ansparung der gesetzlich vorgeschriebenen Mittel',
        },
        {
          id: '1',
          text: 'Beitrag des Sicherungssystems zur St\u00fctzung der Nord/LB',
        },
        { id: '2', text: 'Start des Zusatzfonds Aufbaus' },
        {
          id: '3',
          text: 'J\u00e4hrliche Erfolgsbelastung ohne Institutssicherung',
        },
      ],
      answers: [
        { id: '0', text: 'Ab 2025' },
        { id: '1', text: 'Rund 1 Mrd. Euro' },
        { id: '3', text: 'Rund 800 Mio. Euro' },
        { id: '2', text: 'Mitte 2024' },
      ],
      answerMapping: { '1': '3', '2': '0', '3': '1', '0': '2' },
      times_in_video: [188.5],
      maxTries: 2,
    },
  ],
  references: [ {
    id: '1',
    data:{
       text: 'Learn More About Backend Testing',
    url: 'https://example.com/backend-testing',
    },
    start_time: 3,
    end_time: 10,
    type: 'info',
  },],
  chapters: [
    {
      title: 'Full Backend Test Training',
      start: 0,
      end: 5.225,
    },
    {
      title: 'Introduction to Backend Testing',
      start: 5.225,
      end: 29.816000000000003,
    },
    { title: 'Unit Testing', start: 29.816000000000003, end: 44.484 },
    {
      title: 'Integration Testing',
      start: 44.484,
      end: 59.807,
    },
    { title: 'Functional Testing', start: 59.807, end: 72.45700000000001 },
    {
      title: 'Load Testing',
      start: 72.45700000000001,
      end: 88.04450000000001,
    },
    {
      title: 'Security Testing',
      start: 88.04450000000001,
      end: 102.09450000000001,
    },
    {
      title: 'API Testing',
      start: 102.09450000000001,
      end: 118.29450000000001,
    },
    { title: 'Conclusion', start: 118.29450000000001, end: 138.57750000000001 },
    {
      title: 'Thank you!',
      start: 138.57750000000001,
      end: 362.1,
    },
  ],
  subtitles: [
    'T',
    'h',
    'i',
    's',
    ' ',
    'i',
    's',
    ' ',
    'a',
    ' ',
    't',
    'r',
    'a',
    'i',
    'n',
    'i',
    'n',
    'g',
    ' ',
    'v',
    'i',
    'd',
    'e',
    'o',
    ' ',
    'a',
    'b',
    'o',
    'u',
    't',
    ' ',
    'f',
    'u',
    'l',
    'l',
    ' ',
    'b',
    'a',
    'c',
    'k',
    'e',
    'n',
    'd',
    ' ',
    't',
    'e',
    's',
    't',
    ' ',
    'a',
    't',
    ' ',
    'N',
    'o',
    'n',
    'e',
    '.',
    'E',
    'v',
    'e',
    'r',
    'y',
    ' ',
    't',
    'e',
    's',
    't',
    ' ',
    'm',
    'e',
    'n',
    't',
    'i',
    'o',
    'n',
    'e',
    'd',
    ' ',
    'i',
    's',
    ' ',
    'c',
    'r',
    'u',
    'c',
    'i',
    'a',
    'l',
    ' ',
    'f',
    'o',
    'r',
    ' ',
    'm',
    'a',
    'k',
    'i',
    'n',
    'g',
    ' ',
    's',
    'u',
    'r',
    'e',
    ' ',
    't',
    'h',
    'e',
    ' ',
    'b',
    'a',
    'c',
    'k',
    'e',
    'n',
    'd',
    ' ',
    'o',
    'f',
    ' ',
    'a',
    'n',
    ' ',
    'a',
    'p',
    'p',
    'l',
    'i',
    'c',
    'a',
    't',
    'i',
    'o',
    'n',
    ' ',
    'i',
    's',
    ' ',
    's',
    't',
    'r',
    'o',
    'n',
    'g',
    ',',
    ' ',
    'e',
    'f',
    'f',
    'i',
    'c',
    'i',
    'e',
    'n',
    't',
    ',',
    ' ',
    'a',
    'n',
    'd',
    ' ',
    's',
    'e',
    'c',
    'u',
    'r',
    'e',
    '.',
    ' ',
    'T',
    'h',
    'i',
    's',
    ',',
    ' ',
    'i',
    'n',
    ' ',
    't',
    'u',
    'r',
    'n',
    ',',
    ' ',
    'd',
    'i',
    'r',
    'e',
    'c',
    't',
    'l',
    'y',
    ' ',
    'i',
    'm',
    'p',
    'a',
    'c',
    't',
    's',
    ' ',
    't',
    'h',
    'e',
    ' ',
    's',
    'o',
    'f',
    't',
    'w',
    'a',
    'r',
    'e',
    "'",
    's',
    ' ',
    'o',
    'v',
    'e',
    'r',
    'a',
    'l',
    'l',
    ' ',
    'q',
    'u',
    'a',
    'l',
    'i',
    't',
    'y',
    '.',
    ' ',
    'P',
    'l',
    'e',
    'a',
    's',
    'e',
    ' ',
    'b',
    'e',
    ' ',
    'a',
    'w',
    'a',
    'r',
    'e',
    ' ',
    't',
    'h',
    'a',
    't',
    ' ',
    'a',
    ' ',
    'c',
    'e',
    'r',
    't',
    'a',
    'i',
    'n',
    ' ',
    'd',
    'e',
    't',
    'a',
    'i',
    'l',
    ' ',
    'i',
    'n',
    ' ',
    't',
    'h',
    'i',
    's',
    ' ',
    's',
    'u',
    'm',
    'm',
    'a',
    'r',
    'y',
    ' ',
    'h',
    'a',
    's',
    ' ',
    'b',
    'e',
    'e',
    'n',
    ' ',
    'c',
    'h',
    'a',
    'n',
    'g',
    'e',
    'd',
    ' ',
    'f',
    'o',
    'r',
    ' ',
    's',
    'e',
    'c',
    'u',
    'r',
    'i',
    't',
    'y',
    ' ',
    'p',
    'u',
    'r',
    'p',
    'o',
    's',
    'e',
    's',
    '.',
  ],
};

export const usePlayer = () => {
  let count = 0;
  const videoPlayerRef = useRef<HTMLVideoElement | null>(null);
  const controlRef = useRef<HTMLDivElement | null>(null);

  // create multiple state and not a single state object
  const [playing, setPlaying] = useState<boolean>(false);
  const [muted, setMuted] = useState<boolean>(false);
  const [volume, setVolume] = useState<number>(0.5);
  const [played, setPlayed] = useState<number>(0);
  const [playedSeconds, setPlayedSeconds] = useState<number>(0);
  const [seeking, setSeeking] = useState<boolean>(false);
  const [playbackRate, setPlaybackRate] = useState<number>(1.0);
  const [showSubtitles, setShowSubtitles] = useState(false);
  const [playerType, setPlayerType] = useState<String | undefined>(undefined);
  const [xapiInstance, setXapiInstance] = useState<any>(null);
  const scormInstanceRef = useRef<any>(null);
  const scormCompletedRef = useRef<boolean>(false);
  const [config, setConfig] = useState<Config | undefined>(undefined);
  const [videoSrc, setVideoSrc] = useState<string | undefined>(undefined);
  const [lastXAPISendTime, setLastXAPISendTime] = useState(0);
  const [lastCustomSendTime, setLastCustomSendTime] = useState(0);
  const [quizData, setQuizData] = useState<QuizData>([]);
  const [quizzesTrigger, setQuizzesTrigger] = useState<QuizContainer>([]);
  const [correct, setCorrect] = React.useState<Map<string, boolean>>(new Map<string, boolean>());
  const [videoVersionId, setVideoVersionId] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEndModalOpen, setIsEndModalOpen] = useState(false);
  const [quizSuccess, setQuizSuccess] = useState(false);
  const [quizScore, setQuizScore] = useState(0);
  const { sendEvent, userInfo } = useCustomEvents(videoVersionId);
  const currentTime = videoPlayerRef.current ? videoPlayerRef.current?.currentTime : 0;
  const duration = videoPlayerRef.current ? videoPlayerRef.current?.duration : 0;
  const watchedSecondsRef = useRef<Set<number>>(new Set());
  const [skippedSections, setSkippedSections] = useState<[number, number][]>([]);
  const startSeekTimeRef = useRef<number>(0);
  const [answeredQuizTimes, setAnsweredQuizTimes] = useState<Set<number>>(new Set());
 const [interactiveLinks, setInteractiveLinks] = useState<InteractiveLink[]>([]);
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      const script = document.createElement('script');
      script.src = './static/js/config.js';
      script.id = 'configScript';
      script.async = true;
      script.onload = () => {
        console.log('loading config');
        // @ts-ignore
        const config = window['config'];
        // @ts-ignore
        const videoSrc = window['videoSrc'];
        // @ts-ignore
        const type = window['playerType'];
        // @ts-ignore
        const videoVersionId = window['video_version_id'];
        setConfig(config);
        setVideoSrc(videoSrc);
        setPlayerType(type);
        setVideoVersionId(videoVersionId);
        setInteractiveLinks(config.references || []);
        const language = config.language.startsWith('de') ? 'de' : 'en';
        i18n.changeLanguage(language);
      };

      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    } else {
      // @ts-ignore
      setConfig(configJSON);
      setPlayerType(configJSON.player_type);
      setVideoVersionId(configJSON.video_version_id);
      setInteractiveLinks(configJSON.references || []);
      // @ts-ignore
      import('../assets/video.mp4').then((video) => {
        setVideoSrc(video.default);
      });
      const language = configJSON?.language?.startsWith('de') ? 'de' : 'en';
      i18n.changeLanguage(language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (playerType === 'xAPI') {
      const queryString = window.location.search;
      const queryParams = new URLSearchParams(queryString);
      const parameters: any = {};
      queryParams.forEach((value, key) => {
        try {
          //@ts-ignore
          parameters[key] = JSON.parse(decodeURIComponent(value));
        } catch (e) {
          //@ts-ignore
          parameters[key] = decodeURIComponent(value); // Not JSON, just decode it
        }
      });
      if (parameters) {
        const xapiService = new XAPIService(parameters.activity_id);
        setXapiInstance(xapiService);
        xapiService.initializeStatement('initialized', parameters.activity_id);
      }
    } else if (playerType === 'SCORM') {
      const saw = require('scorm-api-wrapper');
      saw.initialize();
      const lastStatus = saw.getScormValue('cmi.core.lesson_status');
      const isRetryOrComplete = lastStatus === 'failed' || lastStatus === 'passed';

      // Restore video position unless it's a retry/restart
      if (!isRetryOrComplete) {
        const lastKnownLocation = parseFloat(saw.getScormValue('cmi.core.lesson_location'));
        if (videoPlayerRef.current && !isNaN(lastKnownLocation) && lastKnownLocation > 0) {
          videoPlayerRef.current.currentTime = lastKnownLocation;
        }

        // Restore quiz state from suspend_data
        const suspendDataRaw = saw.getScormValue('cmi.suspend_data');
        if (suspendDataRaw) {
          try {
            const suspendData = JSON.parse(suspendDataRaw);
            if (suspendData.quizResults) {
              const restoredCorrect = new Map<string, boolean>(Object.entries(suspendData.quizResults));
              setCorrect(restoredCorrect);
            }
            if (suspendData.answeredQuizTimes && Array.isArray(suspendData.answeredQuizTimes)) {
              setAnsweredQuizTimes(new Set(suspendData.answeredQuizTimes));
            }
          } catch (e) {
            console.log('Failed to parse suspend_data', e);
          }
        }
      }

      scormInstanceRef.current = saw;
    }

    return () => {
      if (playerType === 'SCORM' && scormInstanceRef.current) {
        scormInstanceRef.current.commit();
        scormInstanceRef.current.finish();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playerType]);

  const pauseHandler = () => {
    setPlaying(false);
    videoPlayerRef.current?.pause();
  };
  const handleInteractiveLinkClick = (link: InteractiveLink) => {
    if (videoPlayerRef.current) {
      videoPlayerRef.current.pause();
      setPlaying(false);
    }

    window.open(link.data.url, '_blank', 'noopener,noreferrer');
  };
  const playHandler = () => {
    setPlaying(true);
    videoPlayerRef.current?.play();
    sendEvent({
      video_version_id: videoVersionId,
      user_info: userInfo,
      event_type: 'play',
      event_data: '',
    });
  };

  const playPauseHandler = useCallback(() => {
    //plays and pause the video (toggling)
    if (playing) {
      pauseHandler();
    } else {
      playHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playing, videoVersionId, userInfo]);

  const rewindHandler = () => {
    //Rewinds the video player reducing 5
    if (videoPlayerRef.current) videoPlayerRef.current!.currentTime = videoPlayerRef.current?.currentTime - 5;
  };

  const handleFastFoward = () => {
    //FastFowards the video player by adding 10
    if (videoPlayerRef.current) videoPlayerRef.current!.currentTime = videoPlayerRef.current?.currentTime + 10;
  };

  const progressHandler = (event: ChangeEvent<HTMLVideoElement>) => {
    if (!controlRef.current || !videoPlayerRef.current || isModalOpen) return;
    if (count > 3) {
      controlRef.current.style.opacity = '0'; // toggling player control container
      controlRef.current.style.cursor = 'none';
    } else if (controlRef.current.style.opacity === '1') {
      count += 1;
    }

    if (!seeking) {
      setPlayed(videoPlayerRef.current?.currentTime / videoPlayerRef.current?.duration);
      setPlayedSeconds(videoPlayerRef.current?.currentTime);
    }

    if (isModalOpen) return;
    const currentTime = videoPlayerRef.current.currentTime;
    const currentSecond = Math.floor(currentTime);
    watchedSecondsRef.current.add(currentSecond);
    //send custom event every 10 secs
    const now = Math.floor(currentTime);
    if (now - lastCustomSendTime >= 10) {
      const duration = videoPlayerRef.current.duration || 1;
      const currentUniqueSeconds = watchedSecondsRef.current.size;
      const watchPercentage = (currentUniqueSeconds / duration) * 100;

      sendEvent({
        video_version_id: videoVersionId,
        user_info: userInfo,
        event_type: 'progress',
        event_data: JSON.stringify({
          currentPosition: currentTime,
          totalUniqueSeconds: currentUniqueSeconds,
          watchPercentage: watchPercentage.toFixed(1),
        }),
      });
      setLastCustomSendTime(now);
    }
    if (playerType === 'SCORM' && scormInstanceRef.current && !scormCompletedRef.current) {
      scormInstanceRef.current.setScormValue('cmi.core.lesson_location', currentTime.toString());
      scormInstanceRef.current.setScormValue('cmi.core.lesson_status', 'incomplete');
      if (now - lastCustomSendTime >= 10) {
        const suspendData = JSON.stringify({
          quizResults: Object.fromEntries(correct),
          answeredQuizTimes: Array.from(answeredQuizTimes),
        });
        scormInstanceRef.current.setScormValue('cmi.suspend_data', suspendData);
        scormInstanceRef.current.commit();
      }
    } else if (playerType === 'xAPI') {
      const now = Math.floor(currentTime);
      if (now - lastXAPISendTime >= 10) {
        const time = convertSecondsToIsoDuration(currentTime);
        xapiInstance.sendLastKnownLocation('progressed', time);
        xapiInstance.sendStatement('incomplete');
        setLastXAPISendTime(now);
      }
    }

    const quizTrigger = quizzesTrigger.find(
      (quizTrigger) => quizTrigger.time <= Math.floor(currentTime) && !quizTrigger.displayed
    );
    if (quizTrigger) {
      // Skip quizzes already answered in a previous session
      if (answeredQuizTimes.has(quizTrigger.time)) {
        quizTrigger.displayed = true;
      } else {
        pauseHandler();
        if (playerType === 'xAPI') {
          xapiInstance.sendStatement('attempted');
        }
        setQuizData(quizTrigger.quizzes);
        setIsModalOpen(true);
        quizTrigger.displayed = true;
        setAnsweredQuizTimes((prev) => new Set(prev).add(quizTrigger.time));
      }
    }
  };

  const handleQuizAttemptEvent = (quizIndex: number, result: boolean) => {
    const eventdata = {
      quizIndex: quizIndex,
      result,
    };
    sendEvent({
      video_version_id: videoVersionId, // Replace 'uuid' with the actual UUID for the video version
      user_info: userInfo,
      event_type: 'quiz_attempted',
      event_data: JSON.stringify(eventdata),
    });
  };

  function convertSecondsToIsoDuration(seconds: number): string {
    const totalSeconds = Math.floor(seconds);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const remainingSeconds = totalSeconds % 60;

    let duration = 'PT';

    if (hours > 0) {
      duration += `${hours}H`;
    }
    if (minutes > 0) {
      duration += `${minutes}M`;
    }
    if (remainingSeconds > 0) {
      duration += `${remainingSeconds}S`;
    }

    return duration;
  }
  const endHandler = (event: ChangeEvent<HTMLVideoElement>) => {
    const totalNumberOfQuizzes = correct.size;
    const correctAnswers = Array.from(correct.values()).filter((value) => value).length;
    const correctPercentage = totalNumberOfQuizzes > 0 ? (correctAnswers / totalNumberOfQuizzes) * 100 : 0;
    if (totalNumberOfQuizzes > 0 && correctPercentage >= (config?.passing_percentage ?? 70)) {
      setQuizSuccess(true);
    }
    setQuizScore(correctPercentage);

    const totalTimeSpent = videoPlayerRef.current?.currentTime || 0;
    const duration = videoPlayerRef.current?.duration || 0;

    // Calculate metrics
    const totalUniqueSeconds = watchedSecondsRef.current.size;
    const watchPercentage = duration > 0 ? (totalUniqueSeconds / duration) * 100 : 0;
    const completed = watchPercentage >= 90;

    // Prepare event data
    const eventData = {
      quiz_result: (correctAnswers / totalNumberOfQuizzes) * 100,
      totalUniqueSeconds,
      watchPercentage: watchPercentage.toFixed(1),
      completed: completed ? 'Yes' : 'No',
    };

    sendEvent({
      video_version_id: videoVersionId,
      user_info: userInfo,
      event_type: 'finished',
      event_data: JSON.stringify(eventData),
    });

    if (playerType === 'SCORM' && scormInstanceRef.current) {
      scormInstanceRef.current.setScormValue('cmi.core.score.raw', correctPercentage.toString());
      scormInstanceRef.current.setScormValue('cmi.core.score.min', '0');
      scormInstanceRef.current.setScormValue('cmi.core.score.max', '100');
      scormInstanceRef.current.setScormValue('cmi.core.lesson_status', 'passed');
      // Clear suspend_data on completion so a retry starts clean
      scormInstanceRef.current.setScormValue('cmi.suspend_data', '');
      scormCompletedRef.current = true;
      scormInstanceRef.current.commit();
    } else if (playerType === 'xAPI') {
      const time = convertSecondsToIsoDuration(duration);
      if (correctPercentage >= (config?.passing_percentage ?? 70)) {
        xapiInstance.sendQuizResult('completed', true, correctPercentage, 100, time);
        xapiInstance.sendStatement('pass', time);
        setQuizSuccess(true);
      } else {
        xapiInstance.sendQuizResult('completed', false, correctPercentage, 100, time);
        xapiInstance.sendStatement('fail', time);
      }
      xapiInstance.sendStatement('terminate', time);
    } else {
      if (correctPercentage >= (config?.passing_percentage ?? 70)) {
        setQuizSuccess(true);
      }
    }
    setIsEndModalOpen(true);
  };

  useEffect(() => {
    // Go over all questions and store their times in an array containing the quiz and the start time. if the start array contains multiple entries, add the quiz multiple times, once for each start time.
    // if multiple quizzes have the same start time, add then in an array
    const quizzesTrigger: QuizContainer = [];
    config?.quizzes.forEach((quiz) => {
      quiz.times_in_video.forEach((time) => {
        const quizTrigger = quizzesTrigger.find((quizTrigger) => quizTrigger.time === time);
        if (quizTrigger) {
          quizTrigger.quizzes.push(quiz);
        } else {
          quizzesTrigger.push({ time, quizzes: [quiz], displayed: false });
        }
      });
    });

    quizzesTrigger.sort((a, b) => a.time - b.time);
    setQuizzesTrigger(quizzesTrigger);
  }, [config]);

  const seekHandler = (value: number | number[]) => {
    try {
      value = value as number; //Typecasting due to NextUI Slider
      if (videoPlayerRef.current) {
        setPlayed(value / videoPlayerRef.current?.duration);
        setPlayedSeconds(value);
        videoPlayerRef.current!.currentTime = value;
      }
    } catch (e) {
      console.log(e);
    }
  };

  const seekMouseUpHandler = (value: number | number[]) => {
    try {
      value = value as number; //Typecasting due to NextUI Slider
      setSeeking(false);
      if (videoPlayerRef.current) {
        const endSeekTime = value;
        const startSeekTime = startSeekTimeRef.current;

        if (endSeekTime > startSeekTime + 1) {
          setSkippedSections((prev) => [...prev, [startSeekTime, endSeekTime]]);
        }

        setPlayed(value / videoPlayerRef.current?.duration);
        setPlayedSeconds(value);
        videoPlayerRef.current!.currentTime = value;
      }
    } catch (e) {
      console.log(e);
    }
  };

  const volumeChangeHandler = (value: number | number[]) => {
    try {
      value = value as number;
      const newVolume = value / 100;

      setVolume(newVolume);
      videoPlayerRef.current!.volume = newVolume;
      setMuted(newVolume === 0);
    } catch (e) {
      console.log(e);
    }
  };

  const volumeSeekUpHandler = (value: number | number[]) => {
    try {
      value = value as number;
      const newVolume = value / 100;

      setVolume(newVolume);
      videoPlayerRef.current!.volume = newVolume;
      setMuted(newVolume === 0);
    } catch (e) {
      console.log(e);
    }
  };

  const muteHandler = useCallback(() => {
    //Mutes the video player
    setMuted(!muted);
  }, [muted]);

  const handlePlaybackRateChange = (value: number | number[]) => {
    value = value as number;
    setPlaybackRate(value);
    videoPlayerRef.current!.playbackRate = value;
  };

  const onSeekMouseDownHandler = () => {
    setSeeking(true);
    startSeekTimeRef.current = playedSeconds;
  };

  const mouseMoveHandler = () => {
    if (controlRef.current) {
      controlRef.current.style.opacity = '1';
      controlRef.current.style.cursor = 'default';
      count = 0;
    }
  };

  const handleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  const handleSubtitleChange = (value: boolean) => {
    setShowSubtitles(value);
  };

  const isModalOpenToggle = (value: boolean) => {
    setIsModalOpen(value);
  };
  const handleCorrect = (value: any) => {
    setCorrect(value);
  };
  const handleEndModalOpen = (value: boolean) => {
    setIsEndModalOpen(value);
  };
  // Register event listeners for keydown events for pause/mute on mount and cleanup on unmount
  useEffect(() => {
    const keyDownHandler = (event: KeyboardEvent) => {
      if (event.key === ' ') {
        playPauseHandler();
      }
      if (event.key === 'm') {
        muteHandler();
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [playing, muted, playPauseHandler, muteHandler]);
  return {
    handlers: {
      handleFullscreen,
      mouseMoveHandler,
      onSeekMouseDownHandler,
      handlePlaybackRateChange,
      muteHandler,
      volumeSeekUpHandler,
      volumeChangeHandler,
      seekMouseUpHandler,
      seekHandler,
      endHandler,
      progressHandler,
      handleFastFoward,
      rewindHandler,
      handleSubtitleChange,
      playPauseHandler,
      isModalOpenToggle,
      handleCorrect,
      handleEndModalOpen,
      playHandler,
      handleQuizAttemptEvent,
       handleInteractiveLinkClick,
    },
    state: {
      volume,
      played,
      playedSeconds,
      playbackRate,
      showSubtitles,
      videoSrc,
      quizData,
      isEndModalOpen,
      quizSuccess,
      quizScore,
      currentTime,
      duration,
      muted,
      config,
      playing,
      isModalOpen,
      correct,
       interactiveLinks,
    },
    refs: {
      videoPlayerRef,
      controlRef,
    },
  };
};
